var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 29.15H4.4C3.48865 29.15 2.75 28.4114 2.75 27.5V3.3C2.75 2.38865 3.48865 1.65 4.4 1.65H28.6C29.5114 1.65 30.25 2.38865 30.25 3.3V27.5C30.25 28.4114 29.5114 29.15 28.6 29.15Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95001 13.75V19.25",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95001 12.65V11",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.05 4.4V12.1",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.05 13.2V14.85",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 24.75H15.95V25.85H17.05V24.75Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 24.75H19.8V25.85H20.9V24.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 24.75H23.65V25.85H24.75V24.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 24.75H8.25V25.85H9.35V24.75Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 24.75H12.1V25.85H13.2V24.75Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.05H18.199C19.646 6.05 20.9 7.37055 20.9 8.75105C20.9 9.14375 20.8087 9.5315 20.6333 9.88295C20.493 10.164 20.35 10.45 20.35 10.45V11.55C20.35 13.6763 18.6263 15.4 16.5 15.4C14.3737 15.4 12.65 13.6763 12.65 11.55V9.04805",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 9.35H13.7665C12.5422 9.35 11.55 8.35725 11.55 7.1335C11.55 6.4141 11.638 5.69745 11.8129 4.99895L11.8899 4.6915C11.9372 4.5023 12.1027 4.4 12.2694 4.4C12.3882 4.4 12.5048 4.45665 12.5812 4.5716L12.8392 4.95825C13.283 5.6243 14.0404 6.05 14.8786 6.05H17.05",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3321 21.8713L22.6072 20.2262C21.9038 18.6301 20.3247 17.6 18.5807 17.6H14.4194C12.6753 17.6 11.0963 18.6301 10.3928 20.2257L9.66791 21.8707",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.65 31.35H20.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31.35H23.65",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4adcc1aa.svg";
export { ForwardRef as ReactComponent };